import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1df3f398"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "export-img-dialog" }
const _hoisted_2 = { class: "thumbnails-view" }
const _hoisted_3 = { class: "configs" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "导出格式：", -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "导出范围：", -1))
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = ["data-range"]
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "图片质量：", -1))
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "忽略在线字体：", -1))
const _hoisted_14 = { class: "config-item" }
const _hoisted_15 = { class: "btns" }

import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import useExport from '@/hooks/useExport'

import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'
import FullscreenSpin from '@/components/FullscreenSpin.vue'
import Switch from '@/components/Switch.vue'
import Slider from '@/components/Slider.vue'
import Button from '@/components/Button.vue'
import RadioButton from '@/components/RadioButton.vue'
import RadioGroup from '@/components/RadioGroup.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportImage',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const { slides, currentSlide } = storeToRefs(useSlidesStore())

const imageThumbnailsRef = ref<HTMLElement>()
const rangeType = ref<'all' | 'current' | 'custom'>('all')
const range = ref<[number, number]>([1, slides.value.length])
const format = ref<'jpeg' | 'png'>('jpeg')
const quality = ref(1)
const ignoreWebfont = ref(true)

const renderSlides = computed(() => {
  if (rangeType.value === 'all') return slides.value
  if (rangeType.value === 'current') return [currentSlide.value]
  return slides.value.filter((item, index) => {
    const [min, max] = range.value
    return index >= min - 1 && index <= max - 1
  })
})

const { exportImage, exporting } = useExport()

const expImage = () => {
  if (!imageThumbnailsRef.value) return
  exportImage(imageThumbnailsRef.value, format.value, quality.value, ignoreWebfont.value)
}

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "thumbnails",
        ref_key: "imageThumbnailsRef",
        ref: imageThumbnailsRef
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(renderSlides.value, (slide) => {
          return (_openBlock(), _createBlock(ThumbnailSlide, {
            class: "thumbnail",
            key: slide.id,
            slide: slide,
            size: 1600
          }, null, 8, ["slide"]))
        }), 128))
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(RadioGroup, {
          class: "config-item",
          value: format.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((format).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(RadioButton, {
              style: {"width":"50%"},
              value: "jpeg"
            }, {
              default: _withCtx(() => [
                _createTextVNode("JPEG")
              ]),
              _: 1
            }),
            _createVNode(RadioButton, {
              style: {"width":"50%"},
              value: "png"
            }, {
              default: _withCtx(() => [
                _createTextVNode("PNG")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(RadioGroup, {
          class: "config-item",
          value: rangeType.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((rangeType).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(RadioButton, {
              style: {"width":"33.33%"},
              value: "all"
            }, {
              default: _withCtx(() => [
                _createTextVNode("全部")
              ]),
              _: 1
            }),
            _createVNode(RadioButton, {
              style: {"width":"33.33%"},
              value: "current"
            }, {
              default: _withCtx(() => [
                _createTextVNode("当前页")
              ]),
              _: 1
            }),
            _createVNode(RadioButton, {
              style: {"width":"33.33%"},
              value: "custom"
            }, {
              default: _withCtx(() => [
                _createTextVNode("自定义")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      (rangeType.value === 'custom')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "title",
              "data-range": `（${range.value[0]} ~ ${range.value[1]}）`
            }, "自定义范围：", 8, _hoisted_9),
            _createVNode(Slider, {
              class: "config-item",
              range: "",
              min: 1,
              max: _unref(slides).length,
              step: 1,
              value: range.value,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((range).value = $event))
            }, null, 8, ["max", "value"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(Slider, {
          class: "config-item",
          min: 0,
          max: 1,
          step: 0.1,
          value: quality.value,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((quality).value = $event))
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createVNode(Switch, {
            value: ignoreWebfont.value,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((ignoreWebfont).value = $event))
          }, null, 8, ["value"]), [
            [_directive_tooltip, '导出时默认忽略在线字体，若您在幻灯片中使用了在线字体，且希望导出后保留相关样式，可选择关闭【忽略在线字体】选项，但要注意这将会增加导出用时。']
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(Button, {
        class: "btn export",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (expImage()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("导出图片")
        ]),
        _: 1
      }),
      _createVNode(Button, {
        class: "btn close",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("关闭")
        ]),
        _: 1
      })
    ]),
    _createVNode(FullscreenSpin, {
      loading: _unref(exporting),
      tip: "正在导出..."
    }, null, 8, ["loading"])
  ]))
}
}

})